export default "__VITE_ASSET__9316c6e3__"